module.exports = __webpack_public_path__ + "static/media/heart-couple.2cf5bc8f.svg";